var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,0C4.5,0,0,4.6,0,10.3c0,4.5,2.9,8.4,6.8,9.7c0.5,0.1,0.7-0.2,0.7-0.5c0-0.2,0-0.9,0-1.7 c-2.8,0.6-3.4-1.4-3.4-1.4C3.7,15.2,3,14.9,3,14.9c-0.9-0.6,0.1-0.6,0.1-0.6c1,0.1,1.5,1.1,1.5,1.1c0.9,1.6,2.3,1.1,2.9,0.9 c0.1-0.7,0.3-1.1,0.6-1.4C6,14.5,3.6,13.6,3.6,9.7c0-1.1,0.4-2,1-2.8C4.5,6.7,4.2,5.7,4.7,4.3c0,0,0.8-0.3,2.7,1.1 C8.3,5.1,9.1,5,10,5c0.9,0,1.7,0.1,2.5,0.3c1.9-1.3,2.7-1.1,2.7-1.1c0.5,1.4,0.2,2.5,0.1,2.7c0.6,0.7,1,1.6,1,2.8 c0,3.9-2.3,4.8-4.6,5.1c0.4,0.3,0.7,0.9,0.7,1.9c0,1.4,0,2.5,0,2.8c0,0.3,0.2,0.6,0.7,0.5c4-1.3,6.9-5.2,6.9-9.7C20,4.6,15.5,0,10,0 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.f8569eb7fa6c5f4c5c0c83174c723cbd.svg";
export { ForwardRef as ReactComponent };